import { CheckCircle2, ArrowRight, X } from 'lucide-react';

export default function CompletionButtons({ onComplete, onShift, onCancel }) {
  return (
    <div className="flex gap-2">
      <button
        onClick={onComplete}
        className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-emerald_emerald-600 text-neutral-50 font-medium rounded-lg hover:bg-emerald_emerald-700 transition-colors focus:outline-none focus:ring-2 focus:ring-emerald_emerald-500 focus:ring-offset-2"
      >
        <CheckCircle2 className="w-5 h-5" />
        <span>Complete</span>
      </button>
      
      <button
        onClick={onShift}
        className="flex-1 flex items-center justify-center gap-2 px-6 py-3 bg-amber-600 text-neutral-50 font-medium rounded-lg hover:bg-amber-700 transition-colors focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
      >
        <ArrowRight className="w-5 h-5" />
        <span>Tomorrow</span>
      </button>
      
      <button
        onClick={onCancel}
        className="flex items-center justify-center px-4 py-3 bg-stone-200 text-stone-700 font-medium rounded-lg hover:bg-stone-300 transition-colors focus:outline-none focus:ring-2 focus:ring-stone-500 focus:ring-offset-2"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}